import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { userEmailSendApiFunc } from "../../apiCalls/apiCalls";
import "../../styles/getInTouch/style.scss";

const GetInTouchComponent = ({ headerName, subHeaderName, ref }) => {
  return (
    <div className="get-in-touch-wrapper" ref={ref}>
      <div className="get-in-touch-sub-wrapper">
        <div className="get-in-touch-heading">
          {headerName ? headerName : "Get in Touch"}
        </div>
        <div className="get-in-touch-sub-heading">
          {subHeaderName
            ? subHeaderName
            : `Ready to elevate your digital presence? Let's start a conversation.`}
        </div>
        <div className="get-in-touch-text-field-wrapper width-100">
          <a
            target="_blank"
            className="get-in-touch-button-wrapper width-100"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeJLEwWsaHsVq6jqyQdHfRDeSby7Uk7uu8lwy__zY1hV08a4Q/viewform?usp=sharing&ouid=111353127767494277038"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </div>
  );
};

export default GetInTouchComponent;
